export default {
  logout(context) {
    return new Promise((resolve) => {
      if (!context.getters.isAuthenticated) {
        resolve();
        return;
      }

      // Sessão vive no BFF (cookie): revoga tokens e remove do Redis
      fetch(`${globalThis.Smart.env.BASE_URL}/auth/logout`, { method: "POST" })
        .catch(() => null)
        .finally(() => {
          context.dispatch("shopping/removeAllShoppingCart")
            .catch(() => null)
            .finally(() => {
              context.commit("setAuthenticated", false);
              resolve();
            });
        });
    });
  },
};
